import React from 'react';
const CancellationPolicy = () => {
  return <div className="w-full" data-id="element-206">
      {/* Header Section */}
      <section className="relative py-20 bg-[#1A5F7A]" data-id="element-207">
        <div className="container mx-auto px-4" data-id="element-208">
          <div className="text-center" data-id="element-209">
            <h1 className="text-4xl font-bold text-white mb-4" data-id="element-210">
              Cancellation Policy
            </h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-211">
              Our fair and transparent cancellation terms
            </p>
          </div>
        </div>
      </section>
      {/* Policy Content */}
      <section className="py-16" data-id="element-212">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-213">
          <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-214">
            <h2 className="text-2xl font-bold text-[#1A5F7A] mb-6" data-id="element-215">
              Cancellation Policy & Exclusions
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-216">
              At Realmpoint, your satisfaction with our service plans is our
              priority. We understand that circumstances can change, so we offer
              a simple and transparent cancellation process to give you peace of
              mind.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-217">
              Cancellation Within 14 Days
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-218">
              You have the right to cancel your service plan within 14 days of
              purchase. If you cancel within this period, you'll receive a full
              refund—no questions asked. This cooling-off period lets you review
              your plan to ensure it meets your needs.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-219">
              Cancellation After 14 Days and Within 28 Days
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-220">
              If you decide to cancel after the initial 14-day period but within
              28 days from purchase, you may be eligible for a partial refund.
              This refund is granted at Realmpoint's discretion, considering any
              services or repairs already provided under your plan.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-221">
              No Cancellations or Refunds After 28 Days
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-222">
              Cancellations and refunds cannot be processed after 28 days from
              the purchase date. Please review your plan carefully and contact
              us promptly if you have any concerns or need assistance.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-223">
              How to Cancel Your Service Plan
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-224">
              To cancel your plan, please contact our customer support team
              using the following:
            </p>
            <ul className="list-disc pl-6 mb-8 text-gray-600" data-id="element-225">
              <li className="mb-2" data-id="element-226">Phone: 0800 055 4969</li>
              <li className="mb-2" data-id="element-227">Email: bijayathakur8098@gmail.com</li>
            </ul>
            <p className="text-gray-600 mb-8" data-id="element-228">
              Once we receive your cancellation request, we'll review your case
              promptly. If eligible, your refund will be processed quickly, and
              you'll receive confirmation when your cancellation and refund are
              complete.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-229">
              Refund Processing
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-230">
              All refunds are made to the original payment method used at
              purchase. For security reasons, we don't process refunds to
              alternative accounts or payment methods.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-231">
              Plan Exclusions and Coverage Limits
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-232">
              To maintain fairness and service quality, the following are
              excluded from coverage under your Realmpoint plan:
            </p>
            <ul className="list-disc pl-6 mb-8 text-gray-600" data-id="element-233">
              <li className="mb-2" data-id="element-234">
                <span className="font-medium" data-id="element-235">Pre-existing Faults:</span> Faults
                or damage present before your plan started are not covered.
              </li>
              <li className="mb-2" data-id="element-236">
                <span className="font-medium" data-id="element-237">Misuse or Neglect:</span> Damage
                caused by improper use, neglect, accidents, or unauthorized
                repairs is excluded.
              </li>
              <li className="mb-2" data-id="element-238">
                <span className="font-medium" data-id="element-239">Non-standard Repairs:</span>{' '}
                Repairs beyond normal appliance operation or servicing,
                including modifications or alterations, are excluded.
              </li>
              <li className="mb-2" data-id="element-240">
                <span className="font-medium" data-id="element-241">Illegal or Fraudulent Use:</span>{' '}
                Any fraudulent or illegal use of our services will result in
                immediate plan cancellation without refund.
              </li>
              <li className="mb-2" data-id="element-242">
                <span className="font-medium" data-id="element-243">Manufacturer's Guidelines:</span>{' '}
                Appliances not used or maintained as per manufacturer
                instructions are excluded.
              </li>
            </ul>
            <p className="text-gray-600 mb-8" data-id="element-244">
              If any of these exclusions apply, your plan may be voided
              immediately, and you'll lose eligibility for repairs or refunds
              under the plan.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-245">
              Need Help?
            </h3>
            <p className="text-gray-600" data-id="element-246">
              If you have any questions about cancelling your plan or want
              clarification on coverage, please contact our customer service
              team. We're here to support you and ensure you understand your
              options clearly.
            </p>
          </div>
        </div>
      </section>
    </div>;
};
export default CancellationPolicy;